import { render, staticRenderFns } from "./ConfirmInstruction.vue?vue&type=template&id=1931ff5a"
import script from "./ConfirmInstruction.vue?vue&type=script&lang=js"
export * from "./ConfirmInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports